import type {TypographyStyle} from '@mui/material/styles';
import {assert} from 'assert-ts';
import {Fonts} from 'theme/fonts';

type Variant = keyof typeof Fonts;
const importantCache: {[key in Variant]?: TypographyStyle} = {};

export const useImportantFont = (
  variant: Variant | undefined,
): TypographyStyle | undefined => {
  if (!variant) {
    return undefined;
  }

  if (!importantCache[variant]) {
    const font = Fonts[variant] as TypographyStyle;
    const importantFont = Object.keys(font).reduce<TypographyStyle>(
      (acc, key) => {
        const isImportant =
          typeof font[key] === 'string' &&
          (font[key] as string).includes('important');
        acc[key] = isImportant ? font[key] : `${font[key]}!important`;
        return acc;
      },
      {},
    );

    importantCache[variant] = importantFont;
  }

  return assert(importantCache[variant]);
};
